import React from 'react'
import logo from "../../images/TestAssessify.png";
import LanguageSwitcher from '../LanguageSwitcher';

const HeaderGuest = ({ logo: customLogo }: { logo?: string }) => {
  return (
    <div className="w-full flex justify-between pb-3  bg-inherit sticky top-0 cursor-pointer">
      <div className="h-full">
        <img
          src={customLogo || logo}
          alt="Test Assessify"
          className="w-56 h-full object-contain"
        />
      </div>
      <LanguageSwitcher />
    </div>
  )
}

export default HeaderGuest